var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('audio',{ref:"regularMusic",attrs:{"hidden":true,"autoplay":"autoplay","loop":"","controls":""}},[_c('source',{attrs:{"type":"audio/ogg"}}),_vm._v(" "),_c('source',{attrs:{"src":require("@/assets/audio/regular.mp3"),"type":"audio/mpeg"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39ac8af7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/regularMusic/RegularMusic.vue
// module id = null
// module chunks = 